import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";

const CityService = {
  getAllCities: (params) => axiosInstance.get(API_ENDPOINTS.City.GET_ALL_CITIES, {
    params: params,
  }),
};

export default CityService;
